// extracted by mini-css-extract-plugin
export var container = "searchPage-module--container--D3T64";
export var headline = "searchPage-module--headline--ji3yG";
export var title = "searchPage-module--title--3Hbp_";
export var title2 = "searchPage-module--title2--11GnD";
export var results = "searchPage-module--results--19eY6";
export var resultItem = "searchPage-module--resultItem--3YXrU";
export var resultContainer = "searchPage-module--resultContainer--F64_J";
export var image = "searchPage-module--image--20epI";
export var resultTitle = "searchPage-module--resultTitle--2gC3M";